export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const UPDATE_STYLE_CODE = 'UPDATE_STYLE_CODE';
export const DELETE_STYLE_CODE = 'DELETE_STYLE_CODE';
export const ADD_STYLE_CODE = 'ADD_STYLE_CODE';
export const SET_FAVORITE_PHOTOGRAPHERS = 'SET_FAVORITE_PHOTOGRAPHERS';
export const INIT_SET_PHOTOGRAPHER_REQUEST = 'INIT_SET_PHOTOGRAPHER_REQUEST';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';



export const SET_CARDS = 'SET_CARDS';
export const SET_CARD_DEFAULT = 'SET_CARD_DEFAULT';
export const SET_CREDIT = 'SET_CREDIT';
export const SET_CARD_BOOKING = 'SET_CARD_BOOKING';
export const SET_TIME_BOOKING = 'SET_TIME_BOOKING';
export const SET_DATE_BOOKING = 'SET_DATE_BOOKING';
export const SET_PHOTOGRAPHER = 'SET_PHOTOGRAPHER';



/*booking*/

export const  SET_INFO_STEP_ONE ='SET_INFO_STEP_ONE';
export const  SET_BOOKTYPE ='SET_BOOKTYPE';
export const  SET_EVENT_LIST ='SET_EVENT_LIST';
export const  SET_PHOTOSESH_TYPE_NAME ='SET_PHOTOSESH_TYPE_NAME';
export const  SET_PHOTOSESH_EVENT_TYPE ='SET_PHOTOSESH_EVENT_TYPE';
export const  SET_DATA_BOOKING ='SET_DATA_BOOKING';
export const  RESET_BOOKING_INFO ='RESET_BOOKING_INFO';
export const  SET_PHOTOGRAPHERS ='SET_PHOTOGRAPHERS';
export const  REMOVE_DATA_BOOKING ='REMOVE_DATA_BOOKING';


/*booking page*/
export const  SET_PROJECTS ='SET_PROJECTS';
export const  SET_SHOW_MODE ='SET_SHOW_MODE';
export const  SET_FILTER_STATUS ='SET_FILTER_STATUS';
export const  SET_FILTER_TYPE ='SET_FILTER_TYPE';
export const  SET_SMART_MATCH ='SET_SMART_MATCH';



// WEBPACK FOOTER //
// ./src/actions/types.js